// libs
import React, { memo } from 'react';

// styles
import { Wrapper, Icon } from './styles';

// defs
import { INavigationProps } from './types';

// icon
import ChevronLeft from '@nykaa/ui-components/Icons/chevron-left';
import ArrowLeft from '@nykaa/ui-components/Icons/arrow-left';

function Navigation({
  title,
  backAction,
  BackIcon = null,
  hideBackIcon = false,
  className = '',
  backIconClassName = '',
  showBorder = true,
}: INavigationProps) {
  const DefaultIconComponent = (
    <Icon onClick={backAction} data-test="navigation-backIcon">
      {backIconClassName ? <ChevronLeft /> : <ArrowLeft />}
    </Icon>
  );

  return (
    <Wrapper className={className} showBorder={showBorder}>
      {hideBackIcon === false && (BackIcon || DefaultIconComponent)}
      {title && (
        <span data-test={'navigation-title'} className="navigation__title">
          {title}
        </span>
      )}
    </Wrapper>
  );
}

export default memo(Navigation);
